// extracted by mini-css-extract-plugin
export var container = "_kd-0";
export var dotAnimation = "_kd-2";
export var dotsLoading = "_kd-1";